import { Component, OnInit } from '@angular/core';
import { Globalconfig } from '../utility/global.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private globals: Globalconfig) { }

  ngOnInit(): void {
  }
  goto(){
    window.open(this.globals.CURRENT_SERVER_URL+"termsandconditions",'_blank');
  }

}
